import { NgModule } from '@angular/core';
import { AppCalendarComponent } from './app-calendar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import momentPlugin from '@fullcalendar/moment';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  momentPlugin,
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin,
  listPlugin,
]);

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
    MatProgressBarModule,
  ],
  exports: [AppCalendarComponent],
  declarations: [AppCalendarComponent],
  providers: [],
})
export class AppCalendarModule {}
